import React from "react";

type Props = {
  rows?: number;
};

const Cell = ({ className }: { className: string }) => (
  <div className={`h-3 rounded bg-gray-200 animate-pulse ${className}`} />
);

export const KarmaExchangesTableSkeleton: React.FC<Props> = ({ rows = 10 }) => {
  return (
    <>
      {Array.from({ length: rows }).map((_, i) => (
        <tr key={i} className="border-t border-gray-200 bg-white">
          <td className="px-4 py-3 align-middle">
            <Cell className="w-28" />
          </td>
          <td className="px-4 py-3 align-middle">
            <Cell className="w-24" />
          </td>
          <td className="px-4 py-3 align-middle">
            <Cell className="w-28" />
          </td>
          <td className="px-4 py-3 align-middle">
            <Cell className="w-20" />
          </td>
          <td className="px-4 py-3 align-middle">
            <Cell className="w-24" />
          </td>
          <td className="px-4 py-3 align-middle">
            <Cell className="w-24" />
          </td>
          <td className="px-4 py-3 align-middle">
            <div className="h-5 w-24 rounded-full bg-gray-200 animate-pulse" />
          </td>
          <td className="px-4 py-3">
            <div className="ml-auto h-8 w-24 rounded-md bg-gray-200 animate-pulse" />
          </td>
        </tr>
      ))}
    </>
  );
};

export default KarmaExchangesTableSkeleton;
